import { NavItemAccessor } from '../types/navItemAccessor'
import { SELECTABLE_ACCESSORS } from './selectableAccessors'

export const NON_SELECTABLE_ACCESSORS = Object.values(NavItemAccessor).filter(
  (accessor) => !SELECTABLE_ACCESSORS.includes(accessor),
)
